import { Paths } from 'shared/routes/paths';

export const GoalDetailRoutes = [
  {
    path: Paths.GoalDetail,
    lazy: async () => ({ Component: (await import('./summary')).Summary }),
  },
  {
    path: Paths.GoalDetailRoadmap,
    lazy: async () => ({ Component: (await import('./roadmap')).Roadmap }),
  },
  {
    path: Paths.GoalDetailProgress,
    lazy: async () => ({ Component: (await import('./progress')).Progress }),
  },
  {
    path: Paths.GoalDetailTasks,
    lazy: async () => ({ Component: (await import('./tasks')).Tasks }),
  },
];

export const ProjectDetailRoutes = [
  {
    path: Paths.ProjectDetail,
    lazy: async () => ({ Component: (await import('./summary')).Summary }),
  },
  {
    path: Paths.ProjectDetailRoadmap,
    lazy: async () => ({ Component: (await import('./roadmap')).Roadmap }),
  },
  {
    path: Paths.ProjectDetailProgress,
    lazy: async () => ({ Component: (await import('./progress')).Progress }),
  },
  {
    path: Paths.ProjectDetailTasks,
    lazy: async () => ({ Component: (await import('./tasks')).Tasks }),
  },
];
